var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsStairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 -1 23 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-stairs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stairs-person-ascend-1",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 15.5,
    x2: 2.28,
    y2: 14.515,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,23 L10,21.5 C10,21.2238576 10.2238576,21 10.5,21 L14.983,21 L14.983,18.5 C14.983,18.2238576 15.2068576,18 15.483,18 L18.983,18 L18.983,15.5 C18.983,15.2238576 19.2068576,15 19.483,15 L23,15",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.429,
    y1: 8.837,
    x2: 22,
    y2: 6,
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.304,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,9.481 L11.53,9.019 C11.2182172,8.92885743 10.9757802,8.68301109 10.89,8.37 C10.5520734,7.12037919 9.49867502,6.19461775 8.216,6.02 L6.33,5.7 C5.25695411,5.51867505 4.15523763,5.75598436 3.252,6.363 L2.559,6.83 C1.16251609,7.77323016 0.37713062,9.39129968 0.5,11.072 C0.550257912,11.7606991 1.14930092,12.2782579 1.838,12.228 C2.52669908,12.1777421 3.04425791,11.5786991 2.994,10.89 C2.93737159,10.1044028 3.30504039,9.34846963 3.958,8.908 L4.651,8.442 C4.77554725,8.36085414 4.90997409,8.29599319 5.051,8.249 L4.7,13.6 C4.69600041,13.6569298 4.69600041,13.7140702 4.7,13.771 L4.853,15.858 C4.87830316,16.2024802 4.8006858,16.5467114 4.63,16.847 L3.3,19.2 C3.08081756,19.5894195 3.08603746,20.0661904 3.31369341,20.4507177 C3.54134937,20.835245 3.95685502,21.0691099 4.40369341,21.064293 C4.85053181,21.0593255 5.26081756,20.8164195 5.48,20.427 L6.809,18.08 C7.22221975,17.3509431 7.41013018,16.5157856 7.349,15.68 L7.249,14.314 C7.63,14.466 8.122,14.669 8.779,14.954 C9.2356967,15.1532851 9.58541442,15.5383021 9.74,16.012 L10.612,18.662 C10.7918998,19.206065 11.3184567,19.558339 11.89,19.517 C11.9920826,19.510023 12.0928779,19.4901999 12.19,19.458 C12.5055785,19.3548451 12.767208,19.1304736 12.9172609,18.8343067 C13.0673138,18.5381397 13.0934815,18.1944716 12.99,17.879 L12.118,15.231 C11.7398495,14.0797031 10.8881113,13.1446466 9.777,12.661 C8.611,12.155 7.852,11.853 7.335,11.671 L7.54,8.44 L7.854,8.493 C8.15432169,8.53059067 8.40250451,8.74523528 8.483,9.037 C8.79686405,10.1838653 9.68419279,11.0852065 10.826,11.417 L12.397,11.879 C13.0597417,12.0736804 13.7548196,11.6942417 13.9495,11.0315 C14.1441804,10.3687583 13.7647417,9.67368037 13.102,9.479 L13.1,9.481 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsStairs);
export default __webpack_public_path__ + "static/media/icons-stairs.a479b1df166f4a11bfed0bc725970ecb.svg";
export { ForwardRef as ReactComponent };